import { render, staticRenderFns } from "./TakeAwayMenuCategoryFilter.vue?vue&type=template&id=a43aa4b2&"
import script from "./TakeAwayMenuCategoryFilter.vue?vue&type=script&lang=ts&"
export * from "./TakeAwayMenuCategoryFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports